/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

/**
 * Back To Top
 *
 * @author Space-Time Inc.
 * @version 2023-07-18
 */

(() => {
	function init() {
		const OFFSET_Y = 0;

		const btn = document.getElementById('back-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		function scrollHandler() {
			// const btnR = btn.getBoundingClientRect();
			// const btnH = (btnR.bottom - btnR.top);

			const viewBottomY = window.innerHeight + OFFSET_Y/* - btnH*/;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = '';
				btn.classList.add('fixed');
			}

			if (window.scrollY > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2023-02-21
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.user-content *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});

/**
 *
 * The Control Script for the Modal (JS)
 *
 *
 */

document.addEventListener('DOMContentLoaded', function() {
	const openElements = document.querySelectorAll('.item-photo .img-wrap');
	if (! openElements.length) return;
	const closeElements = document.querySelectorAll('.item-photo-modal .frame .close');
	if (! closeElements.length) return;

	const modalElements = document.querySelectorAll('.item-photo-modal .frame');
	if (! modalElements.length) return;
	
	const centerAreaElements = document.querySelectorAll('.item-photo-modal .frame .center-area');
	if (! centerAreaElements.length) return;

	const autoScrollElements = document.querySelectorAll('.list-item-photo');

	const backToTopElement = document.getElementById('back-to-top');


	// -------------------------------------------------------------------------


	for (let i = 0; i < openElements.length; i += 1) {
		openElements[i].addEventListener('click', openEvent, false);
	}

	for (let i = 0; i < closeElements.length; i += 1) {
		closeElements[i].addEventListener('click', function(e) {
			const targetElement  = e.currentTarget.closest('.frame');
			closeEvent(targetElement);
		}, false);
	}

	for (let i = 0; i < centerAreaElements.length; i += 1) {
		centerAreaElements[i].addEventListener('click', function(e) {
			e.stopPropagation();
		}, false);
	}


	for (let i = 0; i < modalElements.length; i += 1) {
		modalElements[i].addEventListener('click', function(e) {
			const targetElement  = e.currentTarget;
			closeEvent(targetElement);
		}, false);
	}

	window.addEventListener('resize', function() {
		for (let i = 0; i < modalElements.length; i += 1) {
			onScroll(modalElements[i]);
		}
	}, { passive: true });

	// -------------------------------------------------------------------------


	function openEvent(e) {

		for (let i = 0; i < autoScrollElements.length; i += 1) {
			autoScrollElements[i].style.animationPlayState = 'paused';
		}

		const targetId       = e.currentTarget.dataset.modalId;
		const scrollBarWidth = window.innerWidth - document.body.clientWidth;
// console.log(window.innerWidth);
// console.log(document.body.clientWidth);
		for (let i = 0; i < modalElements.length; i += 1) {
			const modalId = modalElements[i].dataset.modalId;
			if (targetId === modalId) {
				document.body.style.overflow            = 'hidden';
				document.body.style.paddingRight        = scrollBarWidth + 'px';
				backToTopElement.style.marginRight      = scrollBarWidth + 'px';
				document.documentElement.style.overflow = 'hidden';

				addEventListenerToModal(modalElements[i]);
				onScroll(modalElements[i]);

				modalElements[i].classList.add('open');
				setTimeout(() => {
					modalElements[i].classList.add('visible');
				}, 100);
				break;
			}
		}
	}

	function closeEvent(element) {

		element.classList.remove('visible');
		setTimeout(() => {
			element.classList.remove('open');
			document.body.removeAttribute('style');
			document.documentElement.removeAttribute('style');
			backToTopElement.removeAttribute('style');
		}, 200);


		removeEventListenerFromModal(element);

		for (let i = 0; i < autoScrollElements.length; i += 1) {
			autoScrollElements[i].style.animationPlayState = 'running';
		}

	}


	// -----------------------------------------------------------------------------


	function addEventListenerToModal(targetElement) {

		targetElement.addEventListener('scroll', listenerForModal, { passive: true });

		if ('ontouchstart' in window) {
			targetElement.addEventListener('touchmove', listenerForModal, { passive: true });
		}
	}

	function removeEventListenerFromModal(targetElement) {
		targetElement.removeEventListener('scroll', listenerForModal);

		if ('ontouchstart' in window) {
			targetElement.removeEventListener('touchmove', listenerForModal);
		}
	}

	function listenerForModal(e) {
		onScroll(e.currentTarget);
	}

	// -----------------------------------------------------------------------------


	function onScroll(targetElement) {
		const btn = document.querySelectorAll('.close');
		if (btn.length === 0) return;

		let bottom;
		if (window.innerWidth < 600) {
			bottom = convertRemToPx(2.275);
		} else {
			bottom = convertRemToPx(2.5);
		}

		for (let i = 0; i < btn.length; i += 1) {

			const viewBottomY = window.innerHeight - bottom;
			const bottomPositionOfParent = btn[i].parentNode.getBoundingClientRect().bottom;
			if (viewBottomY < bottomPositionOfParent) {
				btn[i].style.transform = 'translateY(-' + (bottomPositionOfParent - viewBottomY) + 'px)';
			} else {
				btn[i].removeAttribute('style');
			}
		}
	}
});

function convertRemToPx(rem) {
	var fontSize = getComputedStyle(document.documentElement).fontSize;
	return rem * parseFloat(fontSize);
}

/**
 * Hamburger (JS)
 *
 * @author Space-Time Inc.
 * @version 2023-07-04
 */

document.addEventListener('DOMContentLoaded', () => {
	// const sms = document.querySelectorAll('.part-hamburger li > *:first-child + ul');
	// for (const sm of sms) {
	// 	const label = sm.previousElementSibling;
	// 	label.classList.add('has-child');
	// 	label.addEventListener('click', () => {
	// 		label.classList.toggle('open');
	// 		sm.classList.toggle('open');
	// 	});
	// }

	const ham     = document.querySelector('.part-hamburger');
	const btnClose = document.querySelector('#close-hamburger');
	const overlay = document.getElementById('overlay');

		if (ham && btnClose) {
		btnClose.addEventListener('click', () => {
			ham.classList.remove('open');
			document.body.style.overflow = '';
			overlay.style.display = 'none';
		});
	}
		
	const btnOpens= document.querySelectorAll('.open-hamburger');
	for (let i = 0; i < btnOpens.length; i += 1) {
		if(btnOpens[i]) {
			btnOpens[i].addEventListener('click', () => {
				ham.classList.add('open');
				document.body.classList.add('hidden');
				overlay.style.display = 'block';
				overlay.style.zIndex = '3';
			});
		}
	}
	var scrollheaderHight = 200;
	var scrollThreshold = 500;

	window.addEventListener('scroll', function() {
		// 現在のスクロール位置を取得
		//var scrollY = window.scrollY || window.pageYOffset;
		var scrollY = window.pageYOffset || document.documentElement.scrollTop;
		if (scrollY > scrollheaderHight ) {
			for (let i = 0; i < btnOpens.length; i += 1) {
				if(btnOpens[i] && !btnOpens[i].classList.contains('ready')) {
					btnOpens[i].classList.add('ready');
				}
			}
		} else { 
			for (let i = 0; i < btnOpens.length; i += 1) {
				if(btnOpens[i]) {
					btnOpens[i].classList.remove('ready');
				}
			}
		}
		// スクロール位置が閾値を超えたらfixedに変更
		if (scrollY > scrollThreshold) {
			for (let i = 0; i < btnOpens.length; i += 1) {
				if((btnOpens[i] && !btnOpens[i].classList.contains('fixed'))) {
					btnOpens[i].classList.add('fixed');
				}
			}
		} else {
			for (let i = 0; i < btnOpens.length; i += 1) {
				if(btnOpens[i] && btnOpens[i].classList.contains('fixed')) {
					btnOpens[i].classList.remove('fixed');
				}
			}
		}
	});
});

/**
 * btn-chage (JS)
 *
 * @author Space-Time Inc.
 * @version 2023-07-04
 */

document.addEventListener('DOMContentLoaded', () => {
	const don     = document.querySelector('.donate');
	const stm     = document.querySelector('.stamp');
	

	if (don && stm ) {
		window.addEventListener('scroll', function() {
			if (window.scrollY > window.innerHeight / 3) {
				don.classList.add('after');
				stm.classList.add('after');
			} else {
				don.classList.remove('after');
				stm.classList.remove('after');
			}
		});
	}
	
	const targets = document.querySelectorAll(".part-top-visual");
	// console.log(targets);
	for(let i = targets.length; i--;){
	let observer = new IntersectionObserver((entries, observer) => {
	for(let j = entries.length; j--;){
	if (entries[j].isIntersecting) {
		entries[j].target.classList.add('active');
		observer.unobserve(entries[j].target);
	//    } else{
	//     entries[j].target.classList.remove('active');
	}
	} 
	}, 
	{//
		rootMargin: '-35%'
	});
	observer.observe(targets[i]);
	}
});
		
	